//const dbURL = "http://46.232.128.36:80/errorRegister/modules/";
const dbURL = "https://rejestr-bk.agit.com.pl/modules/"

export { dbURL };
